import { createActions, createState, createReducer } from 'reduxsauce-crud'


export const CentersRedux = createActions(
  {
  },
  {
    prefix: 'CENTERS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = CentersRedux
export const CentersTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})


export const reducer = createReducer(
  INITIAL_STATE, {
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CentersRedux.js